import { render, staticRenderFns } from "./d-table.vue?vue&type=template&id=7158dfe2&scoped=true&"
import script from "./d-table.vue?vue&type=script&lang=js&"
export * from "./d-table.vue?vue&type=script&lang=js&"
import style0 from "./d-table.vue?vue&type=style&index=0&id=7158dfe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7158dfe2",
  null
  
)

export default component.exports